import { useEffect } from "react";

/**
 * Detect if we're on an admin subdomain (e.g. admin.zyroapp.in or admin.<preview>)
 * and swap the PWA manifest link so the installed app registers as "Zyro Admin".
 * Also expose a flag other components can consume.
 */
export function useAdminSubdomain() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = window.location.hostname;
    const isAdmin = host.startsWith("admin.");
    const linkEl = document.querySelector('link[rel="manifest"]');
    if (linkEl) {
      linkEl.href = isAdmin ? "/admin-manifest.json" : "/manifest.json";
    }
    // Set data attribute for CSS/JS consumers
    document.documentElement.dataset.zyroApp = isAdmin ? "admin" : "consumer";
    if (isAdmin) {
      document.title = "Zyro Admin";
    }
  }, []);
}

export function isAdminHost() {
  if (typeof window === "undefined") return false;
  return window.location.hostname.startsWith("admin.");
}
